import React from 'react'
import { customerContainer, storeContainer } from 'src/models'
import LoyaltyForm from '../MyAccountProfile/LoyaltyForm/LoyaltyForm'
import { i18nTranslate } from 'src/utils'
import {
  isAllowedRewardTypeForOptIn,
  isLoyEnableInProf,
} from 'src/views/pages/MyAccount/MyAccountProfile/LoyaltyForm/fixture'
import { loyaltyRewardsFormData } from './fixture'
import './styles.scss'
import { reaction, observable } from 'mobx'
import { observer } from 'mobx-react'
import { enableAccountPrivacy } from 'src/utils/commonUtils'

@observer
class LoyaltyCard extends React.Component {
  @observable homeCountry = storeContainer.currentRegion || ''
  constructor(props) {
    super(props)
  }

  getHomeCountry = () => {
    customerContainer?.profileResponse?.accounts?.properties?.forEach(
      element => {
        if (element.attributeId === 'countryCode') {
          this.homeCountry = element.value
        }
      }
    )
    if (this.homeCountry === 'CA') {
      this.homeCountry = 'Canada'
    }
  }
  async componentDidMount() {
    if (customerContainer.isProfileCallOver) {
      this.getHomeCountry()
    } else {
      const reactions = reaction(
        () => customerContainer.isProfileCallOver,
        (isProfileCallOverNewValue, reaction) => {
          this.getHomeCountry()
          reaction.dispose() // reaction is disposed ( reaction happens only once )
        }
      )
    }
  }

  render() {
    const storeIdBasedOnCountry = storeContainer.storeIDValue

    const hideMessage =
      this.homeCountry === storeIdBasedOnCountry ? '' : 'd-none'
    const showMessage =
      this.homeCountry === storeIdBasedOnCountry
        ? 'd-none'
        : 'non-home-market-country'

    return (
      <div>
        {isAllowedRewardTypeForOptIn() && isLoyEnableInProf() && (
          <>
            <h6 className={`mb-2 privacy_box_header ${hideMessage}`}>
              <div>Nu Skin Rewards</div>
            </h6>
            <div className={`${hideMessage} privacybox p-1`}>
              <LoyaltyForm
                {...loyaltyRewardsFormData}
                parentComponentName="LoyaltyCard"
              />
            </div>
          </>
        )}
        {!enableAccountPrivacy() && (
          <div className={showMessage}>
            {i18nTranslate(
              'myprofile.submit.message',
              'Please switch to your home market to make any changes.'
            )}
          </div>
        )}
      </div>
    )
  }
}
export default LoyaltyCard
